import * as React from 'react';

import * as styles from './FiltersBannerWrapper.css';

export const FiltersBannerWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
